function values() {
    if ($("#value").length) {
        var window_value_height = $("#value").offset().top;
    } else {
        var window_value_height = 0;
    }

    var window_count = window_value_height / 2;
    var window_count_bottom = window_value_height + window_count;
    var scrollinYet = false;
    var $picto1 = $('.value-container').find('.img-1');
    var $picto2 = $('.value-container').find('.img-2');
    var $picto3 = $('.value-container').find('.img-3');

    function animePicto() {
        var scrollvalue = $(window).scrollTop();
        if(scrollvalue > window_count || scrollvalue === window_count_bottom)  {
            scrollinYet = true;
            if(scrollinYet) {
            window.setTimeout(function(){
                $picto1.css('margin-left', '0px');
                window.setTimeout(function(){
                    $picto2.css('margin-left', '0px');
                    window.setTimeout(function(){
                        $picto3.css('margin-left', '0px');
                    }, 200)
                }, 200)
            }, 0)
            }
        }
    }

    $(window).scroll(function(){
        animePicto();
    });
    animePicto();
}

module.exports = function () {
    window.addEventListener('load ready resize', values);
    values();
};
